<script module lang="ts">
  interface windowWithDebug extends Window {
    togglePause?: () => string;
    toggleOverlay?: () => string;
    nextSpot?: () => void;
    help?: string;
  }
  declare let window: windowWithDebug;
  if (window) {
    window.help = `togglePause() -> pause/resume spot. nextSpot() -> skip to next spot. toggleOverlay() => toggle dev overlay.`;
  }
</script>

<script lang="ts">
  import type { Snippet } from "svelte";
  import { getConfigurationContext } from "$lib/elev8Api/configurationContext.svelte";

  interface Props {
    spotIndex?: number;
    spotTimeRemaining?: number;
    spotArrayLength?: number;
    isNewSpotsArray?: boolean;
    next?: () => void;
    spotDuration?: number;
    isPaused?: boolean;
    devOverlay?: boolean;
    children?: Snippet;
  }
  let {
    spotIndex = -1,
    spotTimeRemaining = 0,
    spotArrayLength = 0,
    isNewSpotsArray,
    next,
    spotDuration = $bindable(0),
    isPaused = $bindable(false),
    devOverlay = $bindable(false),
    children,
  }: Props = $props();

  const config = getConfigurationContext();

  $effect(() => {
    if (config.settings.debugging_enabled) {
      devOverlay = true;
    }
  });

  if (window) {
    window.togglePause = togglePause;
    window.nextSpot = nextSpot;
    window.toggleOverlay = () => {
      devOverlay = !devOverlay;
      return `devOverlay: ${devOverlay}`;
    };
  }

  function pause() {
    isPaused = true;
  }

  function resume() {
    isPaused = false;
  }

  function nextSpot() {
    next?.();
  }

  function togglePause() {
    if (isPaused) {
      resume();
    } else {
      pause();
    }
    return `isPaused: ${isPaused}`;
  }
</script>

{#if devOverlay}
  {@render children?.()}
  <div class="flex absolute top-1 right-1 !font-mono z-50">
    <div
      class="flex flex-col justify-center bg-rose-600 *:text-sm px-2 m-2 min-w-[6.75em]"
    >
      <p class="text-white text-left !font-mono">
        Spot: {spotIndex + 1}/{spotArrayLength}
      </p>
      <p
        class="{isPaused
          ? 'text-neutral-600'
          : 'text-white'} text-left min-w-[2em] !font-mono"
      >
        Time: {spotTimeRemaining}{spotDuration > 0 ? `/${spotDuration}` : ""}
      </p>
      {#if isNewSpotsArray !== undefined}
        <p class="text-white text-left !font-mono">
          New?: {isNewSpotsArray ? "Y" : "N"}
        </p>
      {/if}
    </div>
    <button
      class="rounded-lg bg-rose-600 text-white p-3 px-5 text-3xl m-2 cursor-pointer hover:bg-rose-800"
      onclick={nextSpot}
    >
      Next
    </button>
    <button
      class="rounded-lg bg-rose-600 text-white p-3 text-3xl m-2 cursor-pointer hover:bg-rose-800 min-w-[5em]"
      onclick={() => togglePause()}
    >
      {isPaused ? "Resume" : " Pause "}
    </button>
  </div>
{/if}
